function SplideProductExtension(Splide, Components, options) {
  const { on, off, bind, unbind } = SplideEventInterface(Splide);

  function __resizeTrackForSlideAtIndex(index) {
    const slides = Splide.Components.Slides;
    const targetSlideObject = slides.getAt(index);

    if (!targetSlideObject) return;

    const targetSlide = targetSlideObject.slide;
    const targetSlideMedia = targetSlide.querySelector(
      '[data-product-single-media-wrapper]'
    );

    if (!targetSlideMedia) return;
    const targetSlideMediaHeight =
      targetSlideMedia.getBoundingClientRect().height;

    const gridlineWidth =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--gridline-width'
        ),
        10
      ) || 0;

    Splide.root.querySelector('.splide__track').style.maxHeight = `${
      targetSlideMediaHeight + gridlineWidth
    }px`;

    const thumbnailsSplideVerticalEl = Splide.root.parentNode.querySelector(
      '.splide.splide--thumbnails.splide--thumbnails--vertical'
    );

    if (thumbnailsSplideVerticalEl && isLgBreakpoint()) {
      const navHeight =
        Splide.root
          .querySelector('[data-slideshow-navigation]')
          .getBoundingClientRect().height || 0;

      const productContentHeight =
        Splide.root
          .closest('[data-product-media-container]')
          .parentNode.querySelector('[data-product-content]')
          .getBoundingClientRect().height || 0;

      thumbnailsSplideVerticalEl.style.setProperty(
        '--thumbnails-height',
        `${Math.max(
          targetSlideMediaHeight + navHeight,
          productContentHeight
        )}px`
      );
    }
  }

  function __dispatchMediaEvents(newIndex, oldIndex) {
    const slides = Splide.Components.Slides;
    const oldSlide = slides
      .getAt(oldIndex)
      .slide.querySelector('[data-product-single-media-wrapper]');

    const newSlide = slides
      .getAt(newIndex)
      .slide.querySelector('[data-product-single-media-wrapper]');

    if (oldSlide) oldSlide.dispatchEvent(new CustomEvent('mediaHidden'));
    if (newSlide) newSlide.dispatchEvent(new CustomEvent('mediaVisible'));
  }

  function onMounted() {
    __resizeTrackForSlideAtIndex(Splide.index);
  }

  function onResize() {
    __resizeTrackForSlideAtIndex(Splide.index);
  }

  function onSlidesUpdated() {
    __resizeTrackForSlideAtIndex(Splide.index);
  }

  function onWindowResize() {
    __resizeTrackForSlideAtIndex(Splide.index);
  }

  const debouncedWindowResize = debounce(onWindowResize, 150);

  function onMove(newIndex, oldIndex) {
    __resizeTrackForSlideAtIndex(newIndex);
    __dispatchMediaEvents(newIndex, oldIndex);

    Splide.root.dispatchEvent(
      new CustomEvent('move', {
        detail: {
          newIndex,
          oldIndex,
        },
      })
    );
  }

  function onDestroy() {
    unbind(window, 'resize');
  }

  function mount() {
    on('mounted', onMounted);
    on('resize', onResize);
    on('move', onMove);
    on('destroy', onDestroy);
    bind(window, 'resize', debouncedWindowResize);
    on('slides:updated', onSlidesUpdated);

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:unload', (e) => {
        if (
          e.target.contains(Splide.root) &&
          !Splide.state.is(window.Splide.STATES.DESTROYED)
        ) {
          unbind(window, 'resize', debouncedWindowResize);
        }
      });
    }
  }

  return {
    mount,
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data(
    'Theme_Product',
    ({
      product,
      initialVariant,
      optionsWithValues,
      featuredMediaId,
      splideOnDesktop = false,
      mediaScrollTo,
      singleVariantMode,
      alwaysShowProductFeaturedMediaFirst = false,
      firstMediaFullWidth = false,
      shouldUpdateHistoryState = false,
      swapMediaOnDesktop = false,
      templateSuffix = null,
    }) => ({
      productForm: null,
      productRoot: null,
      product,
      featuredMediaId,
      currentMediaId: featuredMediaId,
      splideOnDesktop,
      mediaScrollTo,
      singleVariantMode,
      alwaysShowProductFeaturedMediaFirst,
      firstMediaFullWidth,
      optionsWithValues,
      allOptionPositions: Array.from(
        { length: product.options.length },
        (value, index) => index + 1
      ),
      option1: null,
      option2: null,
      option3: null,
      _soldOutOrUnavailableVariants: null,
      quantity: 1,
      loading: false,
      locked: false,
      optionChangesThisKeypress: 0,
      shouldUpdateHistoryState,
      swapMediaOnDesktop,
      hasGiftCardRecipientForm: false,
      firstMediaView: true,
      addedToCart: false,
      errorMessage: '',
      isMaxLgBreakpoint: window.isMaxLgBreakpoint(),
      maxLgBreakpointMQL: window.maxLgBreakpointMQL(),
      productMediaContainerResizeObserver: null,
      splide: null,
      thumbnailsSplideHorizontal: null,
      thumbnailsSplideVertical: null,
      mainSplideOptions: null,
      thumbnailsSplideHorizontal: null,
      thumbnailsSplideVertical: null,
      thumbnailActiveStatePaused: false,
      splideIndex: 0,
      slideCount: 0,
      allSlides: [],
      allHorizontalThumbnailsSlides: [],
      allVerticalThumbnailsSlides: [],
      splidesInFlux: false,
      splideIsReady: false,
      mediaListIsReordered: false,
      addonGalleryLabel: null,
      displayMagnetPrice: 0,
      displayMagnetSelected: false,
      initDisplayMagnetPricing() {
        const selector = this.productRoot.querySelector('[data-mot-magnet-addon]');
        if (!selector) return;
        const syncMagnetPrice = () => {
          const choice = selector.querySelector('input:checked');
          this.displayMagnetSelected = Boolean(choice?.value);
          this.displayMagnetPrice = this.displayMagnetSelected ? Number(choice.dataset.price) || 0 : 0;
        };
        selector.addEventListener('change', syncMagnetPrice);
        syncMagnetPrice();
      },
      displayHookPrice: 0,
      displayHookSelected: false,
      displayHookLabel: '',
      initDisplayHookPricing() {
        const selector = this.productRoot.querySelector('[data-mot-hook-selector]');
        if (!selector) return;
        this.displayHookLabel = selector.dataset.selectionLabel || '';
        const syncHookPrice = () => {
          const choice = selector.querySelector('input:checked');
          this.displayHookSelected = Boolean(choice?.value);
          this.displayHookPrice = this.displayHookSelected ? Number(choice.dataset.price) || 0 : 0;
        };
        selector.addEventListener('change', syncHookPrice);
        syncHookPrice();
      },
      noteBlockHolderPrice: 0,
      noteBlockHolderSelected: false,
      get noteBlockSelectionPrice() {
        return this.currentPrice + this.noteBlockHolderPrice + this.displayHookPrice + this.displayMagnetPrice;
      },
      initNoteBlockPricing() {
        const holderSelector = this.productRoot.querySelector('[data-mot-note-block-holder-selector]');
        if (!holderSelector) return;
        const syncHolderPrice = () => {
          const choice = holderSelector.querySelector('input:checked');
          this.noteBlockHolderSelected = Boolean(choice?.value);
          this.noteBlockHolderPrice = this.noteBlockHolderSelected ? Number(choice.dataset.price) || 0 : 0;
        };
        holderSelector.addEventListener('change', syncHolderPrice);
        syncHolderPrice();
      },
      templateSuffix,
      get productMediaContainerEl() {
        return this.$root.querySelector('[data-product-media-container]');
      },
      get splideEl() {
        return this.$root.querySelector('.splide:not(.splide--thumbnails)');
      },
      get thumbnailsSplideHorizontalEl() {
        return this.$root.querySelector(
          '.splide.splide--thumbnails:not(.splide--thumbnails--vertical)'
        );
      },
      get thumbnailsSplideVerticalEl() {
        return this.$root.querySelector(
          '.splide.splide--thumbnails.splide--thumbnails--vertical'
        );
      },
      get currentVariant() {
        return this.variantFromOptions();
      },
      set currentVariant(variant) {
        if (this.product.handle === 'fold-display-labels' && this.$root.querySelector('[data-mot-display-labels-addon]')) {
          variant = this.product.variants.find((candidate) => candidate.option1 === variant.option1 && candidate.option2 === 'No') || variant;
        }
        this.option1 = variant.option1;
        this.option2 = variant.option2;
        this.option3 = variant.option3;
      },
      get currentVariantId() {
        if (this.currentVariant) {
          return this.currentVariant.id;
        } else {
          return null;
        }
      },
      get currentVariantAvailable() {
        if (this.currentVariant) {
          return this.currentVariant.available;
        } else {
          return null;
        }
      },
      get currentVariantTitle() {
        if (this.currentVariant && this.currentVariant.title) {
          if (!this.currentVariant.title.includes('Default')) {
            return this.currentVariant.title;
          }
        }
        return '';
      },
      get currentPrice() {
        try{
          document.querySelector('#productPrice').classList.remove("wpd-processed");
          document.querySelector('#productPrice').setAttribute("data-wpd-variant-compare-at-price",this.currentVariant.compare_at_price == null ? "":this.currentVariant.compare_at_price);
          document.querySelector('#productPrice').setAttribute("data-wpd-variant-price",this.currentVariant.price);
          document.querySelector('#productPrice').setAttribute("data-wpd-variant-id",this.currentVariant.id);
          document.querySelector('#productPrice').setAttribute("data-wpd-product-handle",window.wpdExtensionIsProductPage.handle);
        }catch(e){}
        if (this.currentVariant) {
          return this.currentVariant.price;
        } else {
          return 0;
        }
      },
      variantFromOptions(
        option1 = this.option1,
        option2 = this.option2,
        option3 = this.option3
      ) {
        return (
          this.product.variants.find(
            (variant) =>
              variant.option1 === option1 &&
              variant.option2 === option2 &&
              variant.option3 === option3
          ) || null
        );
      },
      getVariantById(id) {
        return (
          this.product.variants.find((variant) => variant.id === id) || null
        );
      },
      clearSingleOptionSelectorDecoration(...classNames) {
        this.productRoot
          .querySelectorAll('[data-single-option-selector]')
          .forEach((optionEl) => {
            optionEl.classList.remove(...classNames);

            if (
              optionEl.tagName === 'BUTTON' &&
              classNames.includes('unavailable') &&
              optionEl.classList.contains('[&.unavailable]:hidden')
            ) {
              optionEl.disabled = false;
            }
          });
      },
      updateSingleOptionSelectorDecoration(
        atPosition,
        withValue,
        ...classNames
      ) {
        this.productRoot
          .querySelectorAll(
            `[data-single-option-selector][data-position="${atPosition}"]`
          )
          .forEach((optionEl) => {
            if (optionEl.value !== withValue) {
              return;
            }

            optionEl.classList.add(...classNames);

            if (
              optionEl.tagName === 'BUTTON' &&
              classNames.includes('unavailable') &&
              optionEl.classList.contains('[&.unavailable]:hidden')
            ) {
              optionEl.disabled = true;
            }
          });
      },
      updateOptionsAvailabilities() {
        this.clearSingleOptionSelectorDecoration('sold-out', 'unavailable');

        /**
         * Compare current options against sold out and
         * unavailable variants where (options.length - 1)
         * options match and decorate the diff option
         */

        const currentSelection = {
          option1: this.option1,
          option2: this.option2,
          option3: this.option3,
        };

        const optionsToDecorate = [];

        for (const variant of this.soldOutOrUnavailableVariants) {
          const { equal, diffKeys } = shallowDiffKeys(
            currentSelection,
            variant,
            ['option1', 'option2', 'option3']
          );

          if (equal === false && diffKeys.length === 1) {
            const diffKey = diffKeys[0];
            const diffKeyPosition = diffKeys[0].split('option')[1];

            optionsToDecorate.push({
              position: diffKeyPosition,
              value: variant[diffKey],
              className: variant.title ? 'sold-out' : 'unavailable',
            });
          } else if (equal === true) {
            for (const position of this.allOptionPositions) {
              optionsToDecorate.push({
                position,
                value: this[`option${position}`],
                className: variant.title ? 'sold-out' : 'unavailable',
              });
            }
          }
        }

        for (const option of optionsToDecorate) {
          this.updateSingleOptionSelectorDecoration(
            option.position,
            option.value,
            option.className
          );
        }
      },
      get soldOutOrUnavailableVariants() {
        if (this._soldOutOrUnavailableVariants)
          return this._soldOutOrUnavailableVariants;

        const allOptionsWithValues = [];

        for (const option of optionsWithValues) {
          allOptionsWithValues.push(option.values);
        }

        const allPossibilities = cartesian(...allOptionsWithValues).map((p) => [
          p[0] ? p[0] : null,
          p[1] ? p[1] : null,
          p[2] ? p[2] : null,
        ]);

        const optionsOfExistingVariants = this.product.variants.map(
          (variant) => [
            variant.option1 ? variant.option1 : null,
            variant.option2 ? variant.option2 : null,
            variant.option3 ? variant.option3 : null,
          ]
        );

        const unavailableVariants = allPossibilities
          .filter(
            (p) =>
              !optionsOfExistingVariants.some(
                (v) => p[0] === v[0] && p[1] === v[1] && p[2] === v[2]
              )
          )
          .map((v) => ({
            option1: v[0] ? v[0] : null,
            option2: v[1] ? v[1] : null,
            option3: v[2] ? v[2] : null,
          }));

        const soldOutVariants = this.product.variants
          .filter((variant) => variant.available === false)
          .map((variant) => ({
            title: variant.title,
            option1: variant.option1,
            option2: variant.option2,
            option3: variant.option3,
          }));

        this._soldOutOrUnavailableVariants =
          soldOutVariants.concat(unavailableVariants);

        return this._soldOutOrUnavailableVariants;
      },
      get isUsingSlideshowToDisplayMedia() {
        if (!this.splide) return false;

        return splideIsNotDestroyed(this.splide);
      },
      init() {
        this.isMaxLgBreakpoint = this.maxLgBreakpointMQL.matches;

        this.maxLgBreakpointMQL.addEventListener('change', (e) => {
          this.isMaxLgBreakpoint = e.matches;
        });

        if (this.singleVariantMode) {
          if (this.templateSuffix !== 'horizontal-gallery') {
            this.$watch('isMaxLgBreakpoint', (value) => {
              this.splidesInFlux = true;

              if (
                (this.templateSuffix === '' && value === true) ||
                this.templateSuffix === 'thumbnails'
              ) {
                setTimeout(() => {
                  this.updateSlidesForMediaGroupWithId(this.currentMediaId);

                  if (splideIsIdle(this.splide)) {
                    // reset splide if breakpoint destroy / init failed
                    this.splide.on('destroy.postBreakpointChange', () => {
                      setTimeout(() => {
                        this.initSplide();
                        this.splidesInFlux = false;
                      });

                      this.splide.off('destroy.postBreakpointChange');
                    });

                    this.splide.destroy();
                  } else {
                    setTimeout(() => {
                      this.splidesInFlux = false;
                    });
                  }
                });
              } else if (this.templateSuffix === '' && value === false) {
                setTimeout(() => {
                  this.resetSlides();

                  setTimeout(() => {
                    this.splidesInFlux = false;
                  });
                });
              }
            });
          } else {
            this.$watch('isMaxLgBreakpoint', (value) => {
              this.triggerWindowResizeForSplide();
            });
          }
        }

        if (Shopify.designMode) {
          /**
           * Handle re-init due to Theme Editor settings change
           */
          this.triggerWindowResizeForSplide();
        }

        /**
         * Handle product media container resize due to changes inside product
         * content like accordions, truncated description, payment button lazy
         * init, etc.
         */

        if (this.productMediaContainerEl) {
          this.productMediaContainerResizeObserver = new ResizeObserver(
            debounce((entries) => {
              const entry = entries[0];

              this.triggerWindowResizeForSplide();
            }, 150)
          );

          this.productMediaContainerResizeObserver.observe(
            this.productMediaContainerEl
          );
        }

        // Set a product root for nested components
        // to use instead of $root (which refers to their root)
        this.productRoot = this.$root;
        const warmCartImage = variant => {
          const source = variant?.featured_image?.src || this.product.featured_image;
          if (!source || typeof source !== 'string') return;
          const url = new URL(source, location.href);
          if (url.hostname !== 'cdn.shopify.com' && url.hostname !== location.hostname) return;
          url.searchParams.delete('width');
          url.searchParams.set('height', '176');
          const image = new Image();
          image.src = url.href;
        };
        const showMobileGallery = () => {
          if (!this.motSwatchScrollUntil || Date.now() > this.motSwatchScrollUntil) return;
          requestAnimationFrame(() => requestAnimationFrame(() => {
            const gallery = this.productMediaContainerEl;
            if (!gallery || !window.matchMedia('(max-width: 1023px)').matches) return;
            const top = Math.max(0, window.scrollY + gallery.getBoundingClientRect().top - 120);
            if (top < window.scrollY) window.scrollTo({top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
          }));
        };
        this.productRoot.addEventListener('change', event => {
          const option = event.target.closest('[data-single-option-selector]');
          if (!option || !window.matchMedia('(max-width: 1023px)').matches) return;
          const name = option.closest('[data-option-name]')?.dataset.optionName || option.name || '';
          if (!/colou?r|finish|size|layout/i.test(name) || /monogram|engraving|gift/i.test(name)) return;
          this.motSwatchScrollUntil = Date.now() + 3000;
          showMobileGallery();
        });
        this.productRoot.addEventListener('mot:gallery:loaded', showMobileGallery);
        warmCartImage(initialVariant);


        this.initNoteBlockPricing();
        this.initDisplayHookPricing();
        this.initDisplayMagnetPricing();

        if (this.$root.querySelector('[x-data="GiftCardRecipient"]')) {
          this.hasGiftCardRecipientForm = true;
        }

        this.$watch('currentVariant', (value, oldValue) => {
          if (!value) return;
          warmCartImage(value);

          if (
            !(this.alwaysShowProductFeaturedMediaFirst && this.firstMediaView)
          ) {
            if (value.featured_media) {
              this.currentMediaId = value.featured_media.id;
            } else {
              this.currentMediaId = this.featuredMediaId;
            }
          }

          if (this.shouldUpdateHistoryState) {
            const url = getUrlWithVariant(window.location.href, value.id);
            window.history.replaceState({ path: url }, '', url);
          }

          if (this.firstMediaView) {
            this.firstMediaView = false;
          }

          document.dispatchEvent(
            new CustomEvent('theme:variant:change', {
              detail: {
                productRootEl: this.productRoot,
                formEl: this.productRoot.querySelector(
                  'form.shopify-product-form'
                ),
                variant: value,
                previousVariant: oldValue,
                product: this.product,
              },
            })
          );

          this.updateNoteBlockGallery();

        });

        this.productRoot.addEventListener('theme:change:variant', (event) => {
          if (!event.detail || !event.detail.variantId) {
            console.error('theme:change:variant requires a variant ID');
            return;
          }

          const variant = this.getVariantById(event.detail.variantId);

          if (!variant) {
            console.error('theme:change:variant: variant not found');
          }

          this.currentVariant = variant;

          this.$nextTick();

          for (const position of [1, 2, 3]) {
            this.productRoot
              .querySelectorAll(
                `[data-single-option-selector][data-position="${position}"]`
              )
              .forEach((optionEl) => {
                optionEl.checked = optionEl.value === this[`option${position}`];
              });
          }
        });

        this.$watch('currentMediaId', async (value, oldValue) => {
          if (!(await this.loadDeferredMediaGroup(value))) return;
          if (this.updateNoteBlockGallery()) return;
          // There can be more than one media (e.g. for different breakpoints)
          // so we check the offsetHeight to see if the wrapper could currently
          // be visible

          // https://davidwalsh.name/offsetheight-visibility

          if (
            this.singleVariantMode &&
            ((this.templateSuffix === '' && this.isMaxLgBreakpoint) ||
              this.templateSuffix === 'thumbnails')
          ) {
            this.thumbnailActiveStatePaused = true;

            this.updateSlidesForMediaGroupWithId(value);

            setTimeout(() => {
              this.thumbnailActiveStatePaused = false;
            }, 100);
          } else {
            this.$root
              .querySelectorAll(
                `[data-product-single-media-wrapper][data-media-id="${oldValue}"]`
              )
              .forEach((mediaWrapperEl) => {
                if (!!mediaWrapperEl.offsetHeight) {
                  if (!this.isUsingSlideshowToDisplayMedia) {
                    mediaWrapperEl.dispatchEvent(
                      new CustomEvent('mediaHidden')
                    );
                  }
                }
              });

            this.$root
              .querySelectorAll(
                `[data-product-single-media-wrapper][data-media-id="${value}"]`
              )
              .forEach((mediaWrapperEl) => {
                if (!!mediaWrapperEl.offsetHeight) {
                  if (this.mediaScrollTo) {
                    if (this.isUsingSlideshowToDisplayMedia) {
                      this.goToSlide(mediaWrapperEl);
                    } else {
                      mediaWrapperEl.dispatchEvent(
                        new CustomEvent('mediaVisible')
                      );
                    }
                  } else {
                    this.updateMedia(mediaWrapperEl.closest('li'));
                  }
                }
              });
          }
        });

        this.currentVariant = initialVariant;

        if (
          this.product.options.length >= 1 &&
          this.product.options.length <= 3
        ) {
          this.updateOptionsAvailabilities();

          this.$watch('option1', (value) => {
            this.updateOptionsAvailabilities();
          });

          this.$watch('option2', (value) => {
            this.updateOptionsAvailabilities();
          });

          this.$watch('option3', (value) => {
            this.updateOptionsAvailabilities();
          });
        }

        this.setUpProductFormEvents();

        this.productRoot.addEventListener('change', (event) => {
          if (event.target.closest('[data-mot-note-block-holder-selector]')) {
            this.updateNoteBlockGallery();
            return;
          }
          const choice = event.target.closest('[data-mot-gallery-label]');
          if (!choice || !choice.checked) return;

          this.updateAddonGalleryForChoice(choice);
        });

        const addToCartBtnEl = this.$root.querySelector('.add-to-cart');

        if (addToCartBtnEl && addToCartBtnEl.offsetHeight) {
          document.documentElement.style.setProperty(
            '--add-to-cart-button-height',
            `${addToCartBtnEl.offsetHeight}px`
          );
        }

        this.allSlides = this.splideEl.querySelectorAll(
          '.splide__slide:not(.product-thumbnail)'
        );

        if (this.thumbnailsSplideHorizontalEl) {
          this.allHorizontalThumbnailsSlides =
            this.thumbnailsSplideHorizontalEl.querySelectorAll(
              '.splide__slide'
            );
        }

        if (this.thumbnailsSplideVerticalEl) {
          this.allVerticalThumbnailsSlides =
            this.thumbnailsSplideVerticalEl.querySelectorAll('.splide__slide');
        }

        this.__setUpSlideshow();

        const initialAddonChoice = this.productRoot.querySelector(
          '[data-mot-gallery-label]:checked'
        );

        if (initialAddonChoice) {
          this.updateAddonGallery(
            initialAddonChoice.dataset.motGalleryLabel || ''
          );
        }

        if (this.singleVariantMode) {
          if (
            (this.templateSuffix === '' && this.isMaxLgBreakpoint) ||
            this.templateSuffix === 'thumbnails'
          ) {
            this.updateSlidesForMediaGroupWithId(this.currentMediaId);
          }
        }

        this.$watch('slideCount', (value) => {
          const dragDisableDefault = !(this.mainSplideOptions.drag === true);

          this.splide.Components.Drag.disable(
            value <= 1 ? true : dragDisableDefault
          );
        });
        this.updateNoteBlockGallery();
      },
      __handleOptionChange(el) {
        const position = parseInt(el.dataset.position, 10);
        const value = el.value.trim();

        this[`option${position}`] = value;
      },
      lockOptionChangeHandler() {
        this.optionChangesThisKeypress++;

        if (this.optionChangesThisKeypress === 2) {
          this.locked = true;
        }
      },
      unlockOptionChangeHandler(el) {
        this.optionChangesThisKeypress = 0;

        if (this.locked === false) return;

        this.__handleOptionChange(el);
        this.locked = false;
      },
      optionChange(el) {
        if (this.locked) return;

        this.__handleOptionChange(el);
      },
      setUpProductFormEvents() {
        this.$root.addEventListener('baseline:productform:loading', (event) => {
          event.stopPropagation();

          this.loading = true;
          this.errorMessage = null;
          this.addedToCart = false;
        });

        this.$root.addEventListener('baseline:productform:success', (event) => {
          event.stopPropagation();

          this.loading = false;
          this.errorMessage = null;
          this.addedToCart = true;

          if (!this.$root.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        });

        // Gift card recipient form errors are handled in gift-card-recipient.js
        if (!this.hasGiftCardRecipientForm) {
          this.$root.addEventListener('baseline:productform:error', (event) => {
            event.stopPropagation();

            this.errorMessage =
              event.detail.message || window.theme.strings.cartError;

            this.quantity = Number(
              this.$root.querySelector('[name="quantity"]').getAttribute('min')
            );

            this.loading = false;
          });
        }
      },
      openZoom(mediaId) {
        const zoomModalId = `image-zoom-${this.productRoot.id}`;

        if (!this.$store.modals.modals[zoomModalId]) {
          this.$store.modals.register(zoomModalId, 'modal');
        }

        this.$watch('$store.modals.modal.contents', (value) => {
          if (value === zoomModalId) {
            this.$nextTick(() => {
              const zoomModalEl = document.getElementById(zoomModalId);

              waitForContent(zoomModalEl).then(() => {
                const mediaEl = zoomModalEl.querySelector(
                  `[data-media-id="${mediaId}"]`
                );

                if (mediaEl) {
                  mediaEl.scrollIntoView();
                }
              });
            });
          }
        });

        this.$store.modals.open(zoomModalId);
      },
      __setUpSlideshow() {
        if (
          !this.splideEl ||
          !this.splideEl.dataset.slideshowEnabled === true
        ) {
          return;
        }

        if (typeof Splide === 'undefined') {
          console.error(
            'product.js requires a Splide object to be defined in the global scope'
          );

          return;
        }

        this.initSplide();

        document.addEventListener('dev:hotreloadmutation', async () => {
          if (!Shopify.designMode) {
            if (!this.singleVariantMode) {
              this.reinitMainSplide();
            } else {
              if (
                (this.templateSuffix === '' && this.isMaxLgBreakpoint) ||
                this.templateSuffix === 'thumbnails'
              ) {
                this.updateSlidesForMediaGroupWithId(this.currentMediaId);
              } else {
                this.reinitMainSplide();
              }
            }
          }
        });
      },
      initSplide() {
        if (this.templateSuffix !== 'horizontal-gallery') {
          this.mainSplideOptions = {
            arrows: Boolean(this.splideEl.querySelector('.splide__arrows')),
            pagination: Boolean(
              this.splideEl.querySelector('.splide__pagination')
            ),
            rewind: true,
            rewindByDrag: true,
            speed: 600,
            drag: true,
            noDrag:
              '[data-product-media-type-model], iframe, model-viewer, button',
            mediaQuery: 'min',
            breakpoints: {},
          };

          if (!this.splideOnDesktop) {
            this.mainSplideOptions.breakpoints['1024'] = {
              destroy: true,
            };
          } else {
            // Preserve the existing desktop behaviour while allowing image
            // slides to remain swipeable on mobile when a product also has
            // video or 3D media.
            this.mainSplideOptions.breakpoints['1024'] = {
              drag: !(this.splideEl.dataset.dragDisabled === 'true'),
              rewindByDrag: false,
            };
          }
        } else {
          this.mainSplideOptions = {
            type: 'slide',
            rewind: true,
            rewindByDrag: true,
            perPage: 1,
            autoWidth: false,
            mediaQuery: 'min',
            breakpoints: {
              1024: {
                fixedWidth: 'auto',
                // fixedWidth: 514,
                rewind: true,
                rewindByDrag: false,
                type: 'slide',
                pagination: true,
                arrows: true,
                drag: !(this.splideEl.dataset.dragDisabled === 'true'),
                classes: {
                  // Add classes for pagination.
                  // pagination:
                  //   'splide__pagination splide__pagination--product flex justify-start items-center mt-4 ml-1 w-auto lg:ml-4', // container
                },
              },
            },
          };
        }

        this.splide = new Splide(this.splideEl, this.mainSplideOptions);

        if (this.thumbnailsSplideHorizontalEl) {
          const mobileOnly =
            this.thumbnailsSplideHorizontalEl.hasAttribute('data-mobile-only');

          const desktopOnly =
            this.thumbnailsSplideHorizontalEl.hasAttribute('data-desktop-only');

          const thumbnailsSplideHorizontalOptions = {
            arrows: false,
            pagination: false,
            rewind: true,
            isNavigation: true,
            // perPage: 5,
            autoWidth: true,
            gap: 'var(--gridline-width)',
          };

          if (mobileOnly) {
            // Splide's free thumbnail dragging can turn one quick swipe into a
            // jump across the full gallery. Handle mobile thumbnail swipes
            // directly so every gesture selects one adjacent product image.
            thumbnailsSplideHorizontalOptions.drag = false;
            thumbnailsSplideHorizontalOptions.mediaQuery = 'min';

            thumbnailsSplideHorizontalOptions.breakpoints = {
              1024: {
                destroy: true,
              },
            };

            this.$watch('isMaxLgBreakpoint', (value) => {
              if (value === true) {
                this.resetSyncedSplide(this.thumbnailsSplideHorizontal);
              }
            });
          } else if (desktopOnly) {
            thumbnailsSplideHorizontalOptions.breakpoints = {
              1023: {
                destroy: true,
              },
            };

            this.$watch('isMaxLgBreakpoint', (value) => {
              if (value === false) {
                this.resetSyncedSplide(this.thumbnailsSplideHorizontal);
              }
            });
          }

          this.thumbnailsSplideHorizontal = new Splide(
            this.thumbnailsSplideHorizontalEl,
            thumbnailsSplideHorizontalOptions
          );

          this.splide.sync(this.thumbnailsSplideHorizontal);

          if (mobileOnly) {
            let thumbnailTouchStartX = null;
            let thumbnailTouchStartY = null;
            let thumbnailSwipeHandled = false;
            const thumbnailSwipeThreshold = 30;

            this.thumbnailsSplideHorizontalEl.addEventListener(
              'touchstart',
              (event) => {
                if (event.touches.length !== 1) return;

                thumbnailTouchStartX = event.touches[0].clientX;
                thumbnailTouchStartY = event.touches[0].clientY;
              },
              { passive: true }
            );

            this.thumbnailsSplideHorizontalEl.addEventListener(
              'touchend',
              (event) => {
                if (
                  thumbnailTouchStartX === null ||
                  thumbnailTouchStartY === null ||
                  !event.changedTouches.length
                ) {
                  return;
                }

                const deltaX =
                  event.changedTouches[0].clientX - thumbnailTouchStartX;
                const deltaY =
                  event.changedTouches[0].clientY - thumbnailTouchStartY;

                thumbnailTouchStartX = null;
                thumbnailTouchStartY = null;

                if (
                  Math.abs(deltaX) < thumbnailSwipeThreshold ||
                  Math.abs(deltaX) <= Math.abs(deltaY)
                ) {
                  return;
                }

                thumbnailSwipeHandled = true;

                const currentIndex = this.splide.index;
                const lastIndex = this.splide.length - 1;
                const nextIndex =
                  deltaX < 0
                    ? Math.min(currentIndex + 1, lastIndex)
                    : Math.max(currentIndex - 1, 0);

                if (nextIndex !== currentIndex) {
                  this.splide.go(nextIndex);
                }

                window.setTimeout(() => {
                  thumbnailSwipeHandled = false;
                }, 350);
              },
              { passive: true }
            );

            this.thumbnailsSplideHorizontalEl.addEventListener(
              'touchcancel',
              () => {
                thumbnailTouchStartX = null;
                thumbnailTouchStartY = null;
              },
              { passive: true }
            );

            this.thumbnailsSplideHorizontalEl.addEventListener(
              'click',
              (event) => {
                if (!thumbnailSwipeHandled) return;

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                thumbnailSwipeHandled = false;
              },
              true
            );
          }
        }

        if (this.thumbnailsSplideVerticalEl) {
          this.thumbnailsSplideVertical = new Splide(
            this.thumbnailsSplideVerticalEl,
            {
              arrows: false,
              pagination: false,
              rewind: true,
              isNavigation: true,
              direction: 'ttb',
              height: 'var(--thumbnails-height)',
              autoHeight: true,
              breakpoints: {
                1023: { destroy: true },
              },
            }
          );

          this.$watch('isMaxLgBreakpoint', async (value) => {
            if (value === false) {
              this.resetSyncedSplide(this.thumbnailsSplideVertical);
            }
          });

          this.splide.sync(this.thumbnailsSplideVertical);
        }

        this.splide.on('ready', () => {
          this.slideCount = this.splide.Components.Slides.get().length;
          this.splideIsReady = true;
        });

        this.splide.mount({ SplideProductExtension });

        if (this.thumbnailsSplideHorizontal) {
          this.thumbnailsSplideHorizontal.mount();
        }

        if (this.thumbnailsSplideVertical) {
          this.thumbnailsSplideVertical.mount();
        }

        this.splideEl.addEventListener('move', (e) => {
          this.splideIndex = e.detail.newIndex;
        });

        if (this.productRoot.classList.contains('mot-wavy-preview') && this.thumbnailsSplideHorizontal) {
          const syncThumbnailHighlight = () => {
            if (!this.isMaxLgBreakpoint) return;
            const activeSlide = this.splide.Components.Slides.getAt(this.splide.index)?.slide;
            const mediaId = activeSlide?.querySelector('[data-media-id]')?.dataset.mediaId;
            if (!mediaId) return;
            this.thumbnailsSplideHorizontalEl.querySelectorAll('[data-thumbnail-media-id]').forEach((thumbnail) => {
              const selected = thumbnail.dataset.thumbnailMediaId === mediaId;
              thumbnail.classList.toggle('is-active', selected);
              if (selected) thumbnail.setAttribute('aria-current', 'true');
              else thumbnail.removeAttribute('aria-current');
            });
          };
          this.splide.on('moved resized updated', syncThumbnailHighlight);
          this.thumbnailsSplideHorizontal.on('moved resized updated', syncThumbnailHighlight);
          this.splide.on('refresh', () => requestAnimationFrame(syncThumbnailHighlight));
        }

        this.splide.on('refresh', () => {
          this.slideCount = this.splide.Components.Slides.get().length;
        });

        this.splide.on('destroy', () => {
          this.splideIsReady = false;
        });
      },
      goToSlide(el) {
        const index = parseInt(el.closest('.splide__slide').dataset.index, 10);

        this.splide.go(index);
      },
      updateMedia(el) {
        if (this.isUsingSlideshowToDisplayMedia) {
          if (!(isLgBreakpoint() && this.swapMediaOnDesktop)) {
            this.goToSlide(el);
          } else {
            this.swapMedia(el);
          }
        } else {
          if (!this.singleVariantMode) {
            this.swapMedia(el);
          }
        }
      },
      swapMedia(el) {
        const incomingEl = el;

        if (this.mediaListIsReordered) {
          this.resetMediaListOrder();
        }

        let restOfIncomingMediaGroup;

        const outgoingEl = this.$refs.mediaList.firstElementChild;

        if (incomingEl.hasAttribute('data-media-group-id')) {
          restOfIncomingMediaGroup = Array.from(
            this.$refs.mediaList.querySelectorAll(
              `[data-media-group-id="${incomingEl.getAttribute(
                'data-media-group-id'
              )}"]`
            )
          )
            .filter((elInGroup) => elInGroup != incomingEl)
            .reverse();
        }

        this.$refs.mediaList.insertBefore(outgoingEl, incomingEl);

        let restOfOutgoingMediaGroup;

        if (outgoingEl.hasAttribute('data-media-group-id')) {
          restOfOutgoingMediaGroup = Array.from(
            this.$refs.mediaList.querySelectorAll(
              `[data-media-group-id="${outgoingEl.getAttribute(
                'data-media-group-id'
              )}"]`
            )
          )
            .filter((elInGroup) => elInGroup != outgoingEl)
            .reverse();
        }

        if (restOfOutgoingMediaGroup && restOfOutgoingMediaGroup.length) {
          let lastInsertedEl = outgoingEl;

          restOfOutgoingMediaGroup.forEach((elInGroup) => {
            this.$refs.mediaList.insertBefore(
              elInGroup,
              lastInsertedEl.nextElementSibling
            );
          });
        }

        this.$refs.mediaList.insertBefore(
          incomingEl,
          this.$refs.mediaList.firstElementChild
        );

        if (restOfIncomingMediaGroup && restOfIncomingMediaGroup.length) {
          let lastInsertedEl = incomingEl;

          restOfIncomingMediaGroup.forEach((elInGroup) => {
            this.$refs.mediaList.insertBefore(
              elInGroup,
              lastInsertedEl.nextElementSibling
            );
          });
        }

        if (this.isUsingSlideshowToDisplayMedia) {
          this.splide.go(0);
        }

        this.mediaListIsReordered = true;
      },
      resetMediaListOrder() {
        const mediaListItemsArray = Array.from(this.$refs.mediaList.children);

        mediaListItemsArray.sort(function (a, b) {
          a = parseInt(a.getAttribute('data-order'), 10);
          b = parseInt(b.getAttribute('data-order'), 10);

          return a > b ? 1 : -1;
        });

        mediaListItemsArray.forEach((mediaListItemEl) => {
          this.$refs.mediaList.appendChild(mediaListItemEl);
        });
      },
      shouldBeFullWidth() {
        if (this.isMaxLgBreakpoint || !this.$el.parentNode) return false;

        const mediaGroupEls = Array.from(
          this.$el.parentNode.querySelectorAll(
            `[data-media-group-id="${this.currentMediaId}"`
          )
        );

        const leftOver = mediaGroupEls.length % 2;

        const index = mediaGroupEls.indexOf(this.$el);

        // First media
        if (index === 0) {
          if (leftOver > 0 || this.firstMediaFullWidth) {
            return true;
          }
        }

        // Last media
        if (index === mediaGroupEls.length - 1) {
          if (this.firstMediaFullWidth && leftOver === 0) {
            return true;
          } else if (this.firstMediaFullWidth && mediaGroupEls.length == 2) {
            return true;
          }
        }

        return false;
      },
      async triggerWindowResizeForSplide() {
        /**
         * Splide’s breakpoint change happens before $nextTick
         * so the slides can still be hidden, either due to `x-cloak`
         * or `x-show` in single variant mode, when it inits.
         *
         * We trigger a resize event on window after $nextTick so
         * the breakpoint change can trigger again once the slides
         * are visible.
         *
         */

        await this.$nextTick();

        window.dispatchEvent(new Event('resize'));
      },
      async resetSyncedSplide(syncedSplide) {
        /**
         * If a splide synced to the main splide is initialized
         * in a breakpoint where it is destroyed, it will
         * remain idle when switching to a breakpoint where it
         * would normally be active, unlike splides that aren’t
         * synced. This resets it, which should only need to
         * happen once.
         *
         */

        if (!splideIsIdle(syncedSplide)) return;

        syncedSplide.destroy();

        await this.$nextTick();

        this.splide.sync(syncedSplide);
        syncedSplide.mount();
      },
      async reinitMainSplide() {
        this.splide.destroy();

        await this.$nextTick();

        this.initSplide();
      },
      normaliseAddonGalleryLabel(value) {
        return String(value || '').trim().toLocaleLowerCase();
      },
      updateNoteBlockGallery() {
        const selector = this.productRoot?.querySelector('[data-mot-note-block-holder-selector]');
        if (!selector || !this.splide || !this.allSlides.length) return false;

        const choice = selector.querySelector('input[type="radio"]:checked');
        if (!choice) return false;
        const holder = choice.nextElementSibling?.querySelector('[data-holder]')?.dataset.holder;
        const rawPad = String(this.currentVariant?.option1 || '').trim().toLowerCase().replace(/[\s_]+/g, '-');
        const pad = rawPad === 'lines' ? 'lined' : rawPad;
        if (!['lined', 'blank', 'dot-grid'].includes(pad) || !['none', 'black', 'white', 'aluminium'].includes(holder)) return false;

        const label = `pad=${pad};holder=${holder}`;
        const hasMatches = Array.from(this.allSlides).some((slide) => this.slideMatchesAddonGalleryLabel(slide, label));
        if (hasMatches) {
          this.updateAddonGalleryForChoice({
            dataset: { motGalleryLabel: label },
            closest: () => selector,
          });
        } else {
          this.addonGalleryLabel = null;
          this.restoreAddonGallerySlides();
        }
        return true;
      },
      slideMatchesAddonGalleryLabel(slide, label) {
        const mediaWrapper = slide.querySelector(
          '[data-product-single-media-wrapper]'
        );
        let rawLabel = mediaWrapper?.dataset.motGalleryLabel;

        if (rawLabel === undefined && slide.dataset.thumbnailMediaId) {
          const sourceMedia = Array.from(this.allSlides).find(
            (sourceSlide) =>
              sourceSlide.querySelector('[data-product-single-media-wrapper]')
                ?.dataset.mediaId === slide.dataset.thumbnailMediaId
          );
          rawLabel = sourceMedia
            ?.querySelector('[data-product-single-media-wrapper]')
            ?.dataset.motGalleryLabel;
        }

        const mediaAlt = this.normaliseAddonGalleryLabel(rawLabel);

        if (label.startsWith('pad=')) {
          const readTags = (text) => {
            const tags = {};
            for (const match of text.matchAll(/(?:^|[\s;\[])\s*(pad|holder)\s*=\s*([a-z-]+)(?=$|[\s;\]])/g)) {
              tags[match[1]] = match[2];
            }
            return tags;
          };
          const actual = readTags(mediaAlt);
          const expected = readTags(label);
          return actual.pad === expected.pad && actual.holder === expected.holder;
        }

        if (label === '') {
          return (
            mediaAlt === '' ||
            mediaAlt === this.normaliseAddonGalleryLabel(this.product.title)
          );
        }

        return mediaAlt.includes(label);
      },
      restoreAddonGallerySlides() {
        if (!this.splide) return;

        const restoreSlides = (splide, slides, selector) => {
          if (!splide) return;

          for (const slide of slides) slide.hidden = false;

          if (!splideIsNotDestroyed(splide)) return;

          splide.Components.Slides.remove(selector);
          splide.Components.Slides.add(Array.from(slides));
        };

        restoreSlides(
          this.splide,
          this.allSlides,
          '.splide__slide:not(.product-thumbnail)'
        );
        restoreSlides(
          this.thumbnailsSplideHorizontal,
          this.allHorizontalThumbnailsSlides,
          '.splide__slide'
        );
        restoreSlides(
          this.thumbnailsSplideVertical,
          this.allVerticalThumbnailsSlides,
          '.splide__slide'
        );
      },
      updateAddonGalleryForChoice(choice) {
        if (!window.matchMedia('(max-width: 1023px)').matches) {
          this.updateAddonGallery(choice.dataset.motGalleryLabel || '');
          return;
        }

        if (this.addonGalleryScrollFrame) {
          cancelAnimationFrame(this.addonGalleryScrollFrame);
          this.addonGalleryScrollFrame = null;
        }

        const anchor = choice.closest('[data-mot-hook-selector]') || choice;
        const anchorTop = anchor.getBoundingClientRect().top;
        const galleries = [
          this.splideEl,
          this.thumbnailsSplideHorizontalEl,
        ].filter((element) => element && element.getBoundingClientRect().height);
        const savedStyles = galleries.map((element) => ({
          element,
          properties: ['height', 'overflow'].map((name) => ({
            name,
            value: element.style.getPropertyValue(name),
            priority: element.style.getPropertyPriority(name),
          })),
        }));

        const restorePosition = () => {
          if (!anchor.isConnected) return;
          const delta = anchor.getBoundingClientRect().top - anchorTop;
          if (Math.abs(delta) > 0.5) {
            window.scrollTo({
              left: window.scrollX,
              top: window.scrollY + delta,
              behavior: 'instant',
            });
          }
        };

        for (const { element } of savedStyles) {
          element.style.setProperty(
            'height',
            `${element.getBoundingClientRect().height}px`,
            'important'
          );
          element.style.setProperty('overflow', 'hidden', 'important');
        }

        try {
          this.updateAddonGallery(choice.dataset.motGalleryLabel || '');
        } finally {
          for (const { element, properties } of savedStyles) {
            for (const { name, value, priority } of properties) {
              if (value) {
                element.style.setProperty(name, value, priority);
              } else {
                element.style.removeProperty(name);
              }
            }
          }
          restorePosition();
        }

        const settledScrollY = window.scrollY;
        this.addonGalleryScrollFrame = requestAnimationFrame(() => {
          this.addonGalleryScrollFrame = null;
          if (Math.abs(window.scrollY - settledScrollY) <= 0.5) {
            restorePosition();
          }
        });
      },
      updateAddonGallery(value) {
        if (!this.splide) return;

        const label = this.normaliseAddonGalleryLabel(value);
        this.addonGalleryLabel = label;
        this.restoreAddonGallerySlides();

        const removeNonMatchingSlides = (splide, slides) => {
          if (!splide) return;

          const sourceSlides = new Set(slides);
          if (splideIsNotDestroyed(splide)) {
            splide.Components.Slides.remove(
              (slideObject) =>
                sourceSlides.has(slideObject.slide) &&
                !this.slideMatchesAddonGalleryLabel(slideObject.slide, label)
            );
          } else {
            for (const slide of slides) {
              slide.hidden = !this.slideMatchesAddonGalleryLabel(slide, label);
            }
          }
        };

        removeNonMatchingSlides(this.splide, this.allSlides);
        removeNonMatchingSlides(
          this.thumbnailsSplideHorizontal,
          this.allHorizontalThumbnailsSlides
        );
        removeNonMatchingSlides(
          this.thumbnailsSplideVertical,
          this.allVerticalThumbnailsSlides
        );

        const matchingSlides = Array.from(this.allSlides).filter((slide) =>
          this.slideMatchesAddonGalleryLabel(slide, label)
        );

        for (const slide of this.allSlides) {
          if (slide.dataset.motDesktopGalleryIndex === undefined) {
            slide.dataset.motDesktopGalleryIndex =
              slide.dataset.desktopGalleryIndex || '';
          }

          slide.dataset.desktopGalleryIndex =
            slide.dataset.motDesktopGalleryIndex;
        }

        // The desktop gallery's feature layout is keyed to indexes 0–3.
        // Give the currently visible hook images those same sequential indexes
        // so every colour uses the exact layout of the default “No” gallery.
        matchingSlides.forEach((slide, index) => {
          slide.dataset.desktopGalleryIndex = String(index);
        });

        if (splideIsNotDestroyed(this.splide)) {
          this.splide.go(0);
          this.splide.emit('slides:updated');
        }
      },
      async loadDeferredMediaGroup(id) {
        const root = this.productRoot;
        if (!root?.hasAttribute('data-mot-deferred-gallery')) return true;
        const key = String(id);
        if (root.dataset.motGalleryGroup === key) return true;
        this.motGalleryCache ||= new Map();
        const mediaContainer = this.productMediaContainerEl;
        mediaContainer?.setAttribute('aria-busy', 'true');
        try {
          let groups = this.motGalleryCache.get(key);
          if (!groups) {
            const variant = this.product.variants.find(item => String(item.featured_media?.id) === key);
            if (!variant) return true;
            const url = new URL(window.location.href);
            url.searchParams.set('section_id', root.dataset.productRoot);
            url.searchParams.set('variant', variant.id);
            const controller = new AbortController();
            const timeout = window.setTimeout(() => controller.abort(), 10000);
            let response;
            try { response = await fetch(url, { signal: controller.signal }); }
            finally { window.clearTimeout(timeout); }
            if (!response.ok) throw new Error('Product photos could not load');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const incoming = doc.querySelector('[data-product-root]');
            if (!incoming || incoming.dataset.motGalleryGroup !== key) throw new Error('Product gallery was unavailable');
            groups = {
              main: Array.from(incoming.querySelectorAll('.splide--product .splide__list > .splide__slide')),
              horizontal: Array.from(incoming.querySelectorAll('.splide--thumbnails:not(.splide--thumbnails--vertical) .splide__list > .splide__slide')),
              vertical: Array.from(incoming.querySelectorAll('.splide--thumbnails--vertical .splide__list > .splide__slide')),
              grid: Array.from(incoming.querySelectorAll('[data-mot-thumbnail-grid]')),
            };
            this.motGalleryCache.set(key, groups);
          }
          if (String(this.currentMediaId) !== key) return false;
          root.dispatchEvent(new CustomEvent('mot:gallery:before-load'));
          const replace = (splide, element, slides, main) => {
            if (!element || !slides.length) return;
            const list = element.querySelector('.splide__list');
            const visible = slides.filter(slide => slide.dataset.mediaGroupId === key);
            const placeholders = Array.from(list.children).filter(node => node.getAttribute('role') === 'presentation');
            Alpine.mutateDom(() => {
              if (splideIsNotDestroyed(splide)) {
                splide.Components.Slides.remove(main ? '.splide__slide:not(.product-thumbnail)' : '.splide__slide');
                splide.Components.Slides.add(visible);
              } else list.replaceChildren(...visible, ...placeholders);
            });
            for (const slide of visible) Alpine.initTree(slide);
            if (splideIsNotDestroyed(splide)) splide.go(0);
          };
          replace(this.splide, this.splideEl, groups.main, true);
          replace(this.thumbnailsSplideHorizontal, this.thumbnailsSplideHorizontalEl, groups.horizontal, false);
          replace(this.thumbnailsSplideVertical, this.thumbnailsSplideVerticalEl, groups.vertical, false);
          const thumbnailGrids = Array.from(root.querySelectorAll('[data-mot-thumbnail-grid]'));
          if (thumbnailGrids.length && groups.grid?.length) {
            Alpine.mutateDom(() => {
              thumbnailGrids[0].replaceWith(...groups.grid);
              thumbnailGrids.slice(1).forEach(grid => grid.remove());
            });
            groups.grid.forEach(grid => Alpine.initTree(grid));
          }
          this.allSlides = groups.main;
          this.allHorizontalThumbnailsSlides = groups.horizontal;
          this.allVerticalThumbnailsSlides = groups.vertical;
          root.dataset.motGalleryGroup = key;
          await this.$nextTick();
          this.splide?.emit('slides:updated');
          root.dispatchEvent(new CustomEvent('mot:gallery:loaded'));
          return true;
        } catch (error) {
          console.error('MOT product gallery:', error);
          return false;
        } finally {
          if (String(this.currentMediaId) === key) mediaContainer?.removeAttribute('aria-busy');
        }
      },
      updateSlidesForMediaGroupWithId(id) {
        if (this.updateNoteBlockGallery()) return;
        if (this.optionsWithValues.some(option => option.name === 'Add monogramming?')) {
          // Swap only the selected colour, in one batch per carousel.
          // Re-adding every colour one slide at a time causes repeated layouts.
          const selectGroup = (splide, slides) => {
            if (!splide || !splideIsNotDestroyed(splide)) return;
            const matching = Array.from(slides).filter(slide => String(slide.dataset.mediaGroupId) === String(id));
            if (!matching.length) return;
            splide.Components.Slides.remove('.splide__slide');
            splide.Components.Slides.add(matching);
            splide.go(0);
          };
          selectGroup(this.splide, this.allSlides);
          selectGroup(this.thumbnailsSplideHorizontal, this.allHorizontalThumbnailsSlides);
          selectGroup(this.thumbnailsSplideVertical, this.allVerticalThumbnailsSlides);
          this.splide?.emit('slides:updated');
          return;
        }
        if (this.slideCount < this.allSlides.length) {
          this.splide.Components.Slides.remove(
            '.splide__slide:not(.product-thumbnail)'
          );

          for (const slide of this.allSlides) {
            this.splide.Components.Slides.add(slide);
          }

          if (this.thumbnailsSplideHorizontal) {
            this.thumbnailsSplideHorizontal.Components.Slides.remove(
              '.splide__slide'
            );

            for (const slide of this.allHorizontalThumbnailsSlides) {
              this.thumbnailsSplideHorizontal.Components.Slides.add(slide);
            }
          }

          if (this.thumbnailsSplideVertical) {
            this.thumbnailsSplideVertical.Components.Slides.remove(
              '.splide__slide'
            );

            for (const slide of this.allVerticalThumbnailsSlides) {
              this.thumbnailsSplideVertical.Components.Slides.add(slide);
            }

            const lastGridlineEl =
              this.thumbnailsSplideVerticalEl.querySelector(
                'li[role="presentation"]'
              );

            this.thumbnailsSplideVerticalEl
              .querySelector('.splide__list')
              .append(lastGridlineEl);
          }
        }

        this.splide.Components.Slides.remove(
          `.splide__slide:not([data-media-group-id="${id}"]):not(.product-thumbnail)`
        );

        this.splide.emit('slides:updated');

        if (this.thumbnailsSplideHorizontal) {
          this.thumbnailsSplideHorizontal.Components.Slides.remove(
            `.splide__slide:not([data-media-group-id="${id}"])`
          );
        }

        if (this.thumbnailsSplideVertical) {
          this.thumbnailsSplideVertical.Components.Slides.remove(
            `.splide__slide:not([data-media-group-id="${id}"])`
          );
        }
      },
      resetSlides() {
        if (this.slideCount < this.allSlides.length) {
          this.splide.Components.Slides.remove(
            '.splide__slide:not(.product-thumbnail)'
          );

          for (const slide of this.allSlides) {
            this.splide.Components.Slides.add(slide);
          }
        }
      },
    })
  );
});
window.motDiaryFoilLabel = function (selectedColour, configuration) {
  if (!selectedColour || !configuration) return '';

  const lines = configuration.split(/\r?\n/);
  for (const line of lines) {
    const separator = line.indexOf('|');
    if (separator === -1) continue;

    const coverColour = line.slice(0, separator).trim();
    const foilColour = line.slice(separator + 1).trim();
    if (coverColour === selectedColour) return foilColour;
  }

  return '';
};

window.motDiaryLimitedBadge = function (variant, configuration) {
  const emptyBadge = { text: '', background: '#463B34', textColour: '#f8f3ed' };
  if (!variant || !configuration) return emptyBadge;

  const selectedOptions = [variant.option1, variant.option2, variant.option3]
    .filter(Boolean)
    .map((option) => String(option).trim());

  const lines = configuration.split(/\r?\n/);
  for (const line of lines) {
    const parts = line.split('|').map((part) => part.trim());
    if (parts.length < 2 || !selectedOptions.includes(parts[0]) || !parts[1]) continue;

    return {
      text: parts[1],
      background: parts[2] || '#463B34',
      textColour: parts[3] || '#f8f3ed',
    };
  }

  return emptyBadge;
};

window.motDiaryLimitedBadgeForId = function (variantId, variantsConfiguration, badgeConfiguration) {
  let variants = [];
  try {
    variants = JSON.parse(variantsConfiguration || '[]');
  } catch (error) {
    return window.motDiaryLimitedBadge(null, badgeConfiguration);
  }

  const variant = variants.find((item) => String(item.id) === String(variantId));
  return window.motDiaryLimitedBadge(variant, badgeConfiguration);
};




